import { SensorData } from 'Simulations/SensorPoint';
import { FilterStage, StageParameters } from '../../Stage';
import Grid from 'Geodata/grid';
import { StageContext } from '../../Context';

export type NoBaseStageParameters = StageParameters & {};

class NoBaseStage extends FilterStage<NoBaseStageParameters> {
    inputSensorIDs: Set<number> = new Set();

    constructor() {
        super({});
    }

    protected override processAll(context: StageContext): StageContext {
        this.inputSensorIDs = new Set(context.sensors.map((s) => s.getID()));
        const outputSensors = context.sensors.map((sensorData) => this.process(sensorData, context)).filter((sd) => sd !== null);
        this.inputSensorIDs.clear();

        return { ...context, sensors: outputSensors };
    }

    protected filter(sensorData: SensorData, _context: StageContext): boolean {
        let isInterrupted = false;
        let currentIndex = sensorData.getSensorPoint().index;
        const coords = Grid.indexToXYZ(currentIndex);

        const x = coords[0],
            y = coords[1],
            z = coords[2];
        const sensorPoints = Grid.sensorPoints;

        // Check each layer below the current sensor
        for (let newZ = z - 1; newZ >= 0 && !isInterrupted; newZ--) {
            const newIndex = Grid.xyzToIndex(x, y, newZ);
            const newSensorID = sensorPoints[newIndex]?.ID;
            if (!this.inputSensorIDs.has(newSensorID)) {
                isInterrupted = true;
                break;
            }
        }
        return !isInterrupted;
    }
}

export default NoBaseStage;
